import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-profile-fill-card',
  templateUrl: './profile-fill-card.component.html',
  styleUrls: ['./profile-fill-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileFillCardComponent implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);
  deviceService = inject(DeviceDetectorService);

  @Input() maxSteps: number;
  @Input() checkedSteps: number;

  public isVisible = true;

  ngOnInit() {}

  onClose(): void {
    this.isVisible = false;
  }

  public get percent(): number {
    if (!this.maxSteps || !this.checkedSteps) {
      return 0;
    }
    return Math.round((100 / this.maxSteps) * this.checkedSteps);
  }

  public navigate(): void {
    if (!this.authService.isAuthenticated) {
      this.authService.showAuthModal();
    } else {
      this.router.navigate(['/profile']);
    }
  }
}
